import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_CUSAT_BY_ID } from 'constants/api';
import { generateURL } from 'helpers';
import { storeName } from '../config';

export const deleteCusat = createAsyncThunk<void, { id: number }>(
  `${storeName}/delete`,
  async ({ id }, thunkAPI) =>
    api.axios
      .delete(generateURL(API_CUSAT_BY_ID, { id }))
      .then(() => undefined)
      .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
